import { PAGE_TYPE } from "enums";
import { getLanguageValue } from "locales/i18n";
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

// 더미 포트폴리오 상세 데이터
const dummyPortfolioDetailData = {
    id: 1,
    title: "Dance Practice - BlackPink 'DDU-DU DDU-DU'",
    description: "BlackPink의 'DDU-DU DDU-DU' 댄스 연습 영상입니다. 강력한 비트와 카리스마 넘치는 안무를 연습했습니다. 특히 포인트 동작과 그룹 포메이션에 중점을 두어 완성도 높은 퍼포먼스를 만들었습니다.",
    videoUrl: "https://thpe-public-stage.s3.amazonaws.com/video/test/u3831574281_Anthropomorphized_animal_neighbors_including_a_pi_79f287c1-3845-44f0-9bea-488623a1166a_0.mp4",
    performedDate: "2024.01.15",
    viewCount: 1250,
    likeCount: 89,
    duration: "3분 45초",
    category: "댄스",
    grade: "S",
    // 캐스팅 매니저 클릭 정보
    castingManagerClicks: [
        {
            id: 1,
            companyName: "SM Entertainment",
            managerName: "김캐스팅",
            clickedDate: "2024.01.16",
            isInterested: true
        },
        {
            id: 2,
            companyName: "JYP Entertainment",
            managerName: "박매니저",
            clickedDate: "2024.01.17",
            isInterested: true
        },
        {
            id: 3,
            companyName: "YG Entertainment",
            managerName: "이디렉터",
            clickedDate: "2024.01.18",
            isInterested: false
        }
    ],
    // 코치 피드백 및 점수
    coachFeedbacks: [
        {
            id: 1,
            coachName: "Koach 김",
            coachImage: "imgs/dummy/koach-1.png",
            rating: 9.2,
            grade: "S",
            feedback: "정말 인상적인 퍼포먼스네요! 특히 안무의 정확도가 높아 보입니다. 그룹 포메이션도 잘 맞춰져 있어요. 다음에는 더 다양한 각도에서 촬영해보세요!",
            date: "2024.01.16",
            categories: {
                dance: 9.5,
                expression: 8.8,
                technique: 9.0,
                stagePresence: 9.3
            }
        },
        {
            id: 2,
            coachName: "Koach 박",
            coachImage: "imgs/dummy/koach-2.png",
            rating: 8.7,
            grade: "A",
            feedback: "전반적으로 좋은 퍼포먼스입니다. 다만 표정 연기가 조금 더 필요해 보여요. 안무는 정확하지만 감정 표현을 더 강화하면 더욱 좋을 것 같습니다.",
            date: "2024.01.17",
            categories: {
                dance: 9.0,
                expression: 7.5,
                technique: 8.8,
                stagePresence: 8.5
            }
        },
        {
            id: 3,
            coachName: "Koach 이",
            coachImage: "imgs/dummy/koach-3.png",
            rating: 9.0,
            grade: "S",
            feedback: "매우 훌륭한 무대입니다! 카리스마와 안무 정확도가 모두 뛰어나요. 특히 포인트 동작에서의 임팩트가 인상적입니다.",
            date: "2024.01.18",
            categories: {
                dance: 9.2,
                expression: 9.0,
                technique: 9.1,
                stagePresence: 9.4
            }
        }
    ],
    comments: [
        {
            id: 1,
            author: "지망생 이",
            content: "정말 멋진 영상이에요! 저도 이런 수준으로 연습하고 싶어요.",
            date: "2024.01.18",
            isKoach: false
        }
    ]
};

const PortfolioDetail = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [portfolio, setPortfolio] = useState(dummyPortfolioDetailData);
    const [isLoading, setIsLoading] = useState(false);
    const [newComment, setNewComment] = useState("");
    const [activeTab, setActiveTab] = useState("feedback"); // "feedback" | "casting" | "comments"

    // 등급별 색상 및 스타일
    const getGradeStyle = (grade: string) => {
        const styles = {
            S: "bg-yellow-500 text-white font-bold border-2 border-yellow-300",
            A: "bg-red-500 text-white font-bold border-2 border-red-300",
            B: "bg-orange-500 text-white font-bold border-2 border-orange-300",
            C: "bg-blue-500 text-white font-bold border-2 border-blue-300",
            D: "bg-green-500 text-white font-bold border-2 border-green-300",
            E: "bg-purple-500 text-white font-bold border-2 border-purple-300",
            F: "bg-gray-500 text-white font-bold border-2 border-gray-300"
        };
        return styles[grade as keyof typeof styles] || styles.F;
    };

    useEffect(() => {
        // 실제로는 API 호출로 포트폴리오 상세 정보를 가져옴
        setIsLoading(true);
        setTimeout(() => {
            setPortfolio(dummyPortfolioDetailData);
            setIsLoading(false);
        }, 500);
    }, [id]);

    const handleBackClick = () => {
        navigate(-1);
    };

    const handleCommentSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!newComment.trim()) return;

        // 댓글 추가 로직
        const comment = {
            id: portfolio.comments.length + 1,
            author: "나",
            content: newComment,
            date: new Date().toLocaleDateString('ko-KR'),
            isKoach: false
        };

        setPortfolio(prev => ({
            ...prev,
            comments: [...prev.comments, comment]
        }));
        setNewComment("");
    };

    const handleLikeClick = () => {
        setPortfolio(prev => ({
            ...prev,
            likeCount: prev.likeCount + 1
        }));
    };

    if (isLoading) {
        return (
            <main className="bg-gray-50 min-h-screen">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-6">
                    <div className="flex justify-center items-center py-12">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#CF3688]"></div>
                    </div>
                </div>
            </main>
        );
    }

    return (
        <main className="bg-gray-50 min-h-screen">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-6 sm:pt-6 lg:pt-6">
                <div className="flex items-center mb-6">
                    <button
                        onClick={handleBackClick}
                        className="inline-flex items-center text-gray-600 hover:text-gray-900"
                    >
                        <svg
                            className="w-6 h-6"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M15 19l-7-7 7-7"
                            />
                        </svg>
                    </button>
                </div>
                <div className="flex items-center justify-between mb-8">
                    <h2 className="text-3xl font-bold text-gray-900">
                        {getLanguageValue(PAGE_TYPE.STUDENT, "profilePortfolio.txtTitle")}
                    </h2>
                </div>

                <div className="max-w-6xl mx-auto space-y-6">
                    {/* 비디오 플레이어 */}
                    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
                        <div className="relative aspect-video">
                            <video
                                src={portfolio.videoUrl}
                                title={portfolio.title}
                                className="w-full h-full"
                                controls
                                preload="metadata"
                                poster="imgs/dummy/thumbnails/portfolio-thumb-1.png"
                            >
                                <source src={portfolio.videoUrl} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    </div>

                    {/* 포트폴리오 기본 정보 */}
                    <div className="bg-white rounded-lg shadow-sm p-6">
                        <div className="flex items-start justify-between mb-4">
                            <div className="flex-1">
                                <div className="flex items-center space-x-3 mb-2">
                                    <h1 className="text-2xl font-bold text-gray-900">
                                        {portfolio.title}
                                    </h1>
                                    <div className={`px-3 py-1 rounded-full text-sm font-bold shadow-lg ${getGradeStyle(portfolio.grade || 'F')}`}>
                                        {portfolio.grade || 'F'}
                                    </div>
                                </div>
                                <div className="flex items-center space-x-4 text-sm text-gray-500 mb-4">
                                    <span>{portfolio.performedDate}</span>
                                    <span>•</span>
                                    <span>{portfolio.duration}</span>
                                    <span>•</span>
                                    <span>{portfolio.category}</span>
                                </div>
                            </div>
                            <button
                                onClick={handleLikeClick}
                                className="flex items-center space-x-2 text-[#CF3688] hover:text-[#B52E74] transition-colors"
                            >
                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                                </svg>
                                <span>{portfolio.likeCount}</span>
                            </button>
                        </div>

                        {/* 조회수 */}
                        <div className="flex items-center text-sm text-gray-500">
                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                            {portfolio.viewCount.toLocaleString()}회 조회
                        </div>
                    </div>

                    {/* 탭 네비게이션 */}
                    <div className="bg-white rounded-lg shadow-sm">
                        <div className="border-b border-gray-200">
                            <nav className="flex space-x-8 px-6">
                                <button
                                    onClick={() => setActiveTab("feedback")}
                                    className={`py-4 px-1 border-b-2 font-medium text-sm ${
                                        activeTab === "feedback"
                                            ? "border-[#CF3688] text-[#CF3688]"
                                            : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                                    }`}
                                >
                                    코치 피드백 ({portfolio.coachFeedbacks.length})
                                </button>
                                <button
                                    onClick={() => setActiveTab("casting")}
                                    className={`py-4 px-1 border-b-2 font-medium text-sm ${
                                        activeTab === "casting"
                                            ? "border-[#CF3688] text-[#CF3688]"
                                            : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                                    }`}
                                >
                                    캐스팅 매니저 ({portfolio.castingManagerClicks.length})
                                </button>
                                <button
                                    onClick={() => setActiveTab("comments")}
                                    className={`py-4 px-1 border-b-2 font-medium text-sm ${
                                        activeTab === "comments"
                                            ? "border-[#CF3688] text-[#CF3688]"
                                            : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                                    }`}
                                >
                                    댓글 ({portfolio.comments.length})
                                </button>
                            </nav>
                        </div>

                        <div className="p-6">
                            {/* 코치 피드백 탭 */}
                            {activeTab === "feedback" && (
                                <div className="space-y-6">
                                    {portfolio.coachFeedbacks.map((feedback) => (
                                        <div key={feedback.id} className="border border-gray-200 rounded-lg p-6">
                                            <div className="flex items-start space-x-4 mb-4">
                                                <div className="flex-shrink-0">
                                                    <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center">
                                                        <span className="text-sm font-medium text-gray-600">
                                                            {feedback.coachName.charAt(0)}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="flex-1">
                                                    <div className="flex items-center space-x-3 mb-2">
                                                        <h3 className="text-lg font-semibold text-gray-900">
                                                            {feedback.coachName}
                                                        </h3>
                                                        <div className={`px-2 py-1 rounded-full text-xs font-bold ${getGradeStyle(feedback.grade)}`}>
                                                            {feedback.grade}
                                                        </div>
                                                        <span className="text-2xl font-bold text-[#CF3688]">
                                                            {feedback.rating}
                                                        </span>
                                                        <span className="text-sm text-gray-500">
                                                            {feedback.date}
                                                        </span>
                                                    </div>
                                                    
                                                    {/* 세부 점수 */}
                                                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                                                        <div className="text-center">
                                                            <div className="text-sm text-gray-500">댄스</div>
                                                            <div className="text-lg font-bold text-gray-900">{feedback.categories.dance}</div>
                                                        </div>
                                                        <div className="text-center">
                                                            <div className="text-sm text-gray-500">표정</div>
                                                            <div className="text-lg font-bold text-gray-900">{feedback.categories.expression}</div>
                                                        </div>
                                                        <div className="text-center">
                                                            <div className="text-sm text-gray-500">테크닉</div>
                                                            <div className="text-lg font-bold text-gray-900">{feedback.categories.technique}</div>
                                                        </div>
                                                        <div className="text-center">
                                                            <div className="text-sm text-gray-500">무대감</div>
                                                            <div className="text-lg font-bold text-gray-900">{feedback.categories.stagePresence}</div>
                                                        </div>
                                                    </div>
                                                    
                                                    <p className="text-gray-700 leading-relaxed">
                                                        {feedback.feedback}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* 캐스팅 매니저 탭 */}
                            {activeTab === "casting" && (
                                <div className="space-y-4">
                                    {portfolio.castingManagerClicks.map((click) => (
                                        <div key={click.id} className="flex items-center justify-between p-4 border border-gray-200 rounded-lg">
                                            <div className="flex items-center space-x-4">
                                                <div className="w-10 h-10 bg-[#CF3688] rounded-full flex items-center justify-center">
                                                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                                    </svg>
                                                </div>
                                                <div>
                                                    <div className="font-semibold text-gray-900">{click.companyName}</div>
                                                    <div className="text-sm text-gray-500">{click.managerName} • {click.clickedDate}</div>
                                                </div>
                                            </div>
                                            <div className="flex items-center space-x-2">
                                                {click.isInterested ? (
                                                    <span className="px-3 py-1 bg-green-100 text-green-800 text-sm rounded-full">
                                                        관심 있음
                                                    </span>
                                                ) : (
                                                    <span className="px-3 py-1 bg-gray-100 text-gray-800 text-sm rounded-full">
                                                        확인함
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {/* 댓글 탭 */}
                            {activeTab === "comments" && (
                                <div>
                                    {/* 댓글 작성 폼 */}
                                    <form onSubmit={handleCommentSubmit} className="mb-6">
                                        <div className="flex space-x-3">
                                            <div className="flex-1">
                                                <textarea
                                                    value={newComment}
                                                    onChange={(e) => setNewComment(e.target.value)}
                                                    placeholder="댓글을 작성해주세요..."
                                                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#CF3688]/20 focus:border-[#CF3688] resize-none"
                                                    rows={3}
                                                />
                                            </div>
                                            <button
                                                type="submit"
                                                className="px-6 py-3 bg-[#CF3688] text-white rounded-lg hover:bg-[#B52E74] transition-colors font-medium"
                                            >
                                                댓글 작성
                                            </button>
                                        </div>
                                    </form>

                                    {/* 댓글 목록 */}
                                    <div className="space-y-4">
                                        {portfolio.comments.map((comment) => (
                                            <div key={comment.id} className="border-b border-gray-100 pb-4 last:border-b-0">
                                                <div className="flex items-start space-x-3">
                                                    <div className="flex-shrink-0">
                                                        <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
                                                            <span className="text-sm font-medium text-gray-600">
                                                                {comment.author.charAt(0)}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="flex-1">
                                                        <div className="flex items-center space-x-2 mb-1">
                                                            <span className="font-medium text-gray-900">
                                                                {comment.author}
                                                            </span>
                                                            {comment.isKoach && (
                                                                <span className="px-2 py-1 bg-[#CF3688] text-white text-xs rounded-full">
                                                                    Koach
                                                                </span>
                                                            )}
                                                            <span className="text-sm text-gray-500">
                                                                {comment.date}
                                                            </span>
                                                        </div>
                                                        <p className="text-gray-700">
                                                            {comment.content}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default PortfolioDetail; 